import useStore from 'hooks/useStore';
import { isEmpty } from 'lodash';
import {
  SET_CURRENT_USER,
  SET_EVENTS,
  SET_LOADING_MESSAGE,
  SET_SHOW_LOADING,
  SET_SHOW_PENDING,
  SET_SHOW_SEARCHING,
} from 'store/action';

const useCommonStore = () => {
  const { state, setState, dispatch } = useStore();
  const {
    isLoading,
    loadingMessage,
    isSearching,
    currentUser,
    portalModal,
    configOccupation,
    configPurpose,
    configSourcesOfWealth,
    events,
  } = state;

  const { isShowPortalModal, namePortalModal } = portalModal || {};

  const setLoading = (isLoading = false) =>
    setState({
      action: SET_SHOW_LOADING,
      payload: isLoading,
    });
  const setLoadingMessage = (message = '') =>
    setState({
      action: SET_LOADING_MESSAGE,
      payload: message,
    });

  const setPending = (isPending = false) =>
    setState({
      action: SET_SHOW_PENDING,
      payload: isPending,
    });

  const setSearching = (isSearching = false) =>
    setState({
      action: SET_SHOW_SEARCHING,
      payload: isSearching,
    });

  const setEvents = (events) => {
    setState({
      action: SET_EVENTS,
      payload: !isEmpty(events) ? events : null,
    });
  };

  const setCurrentUser = (user) => {
    setState({
      action: SET_CURRENT_USER,
      payload: !isEmpty(user) ? user : null,
    });
  };

  return {
    state,
    setState,
    dispatch,
    ...state,
    // STATE
    isLoading,
    loadingMessage,
    isSearching,
    currentUser,
    portalModal,
    isShowPortalModal,
    namePortalModal,
    configOccupation,
    configPurpose,
    configSourcesOfWealth,
    events,
    // DISPATCH
    setLoading,
    setLoadingMessage,
    setSearching,
    setPending,
    setEvents,
    setCurrentUser,
  };
};

export default useCommonStore;
